export async function convert_auto_config(campaign, action_template, self) {

  const auto_condition_action_config = {
    campaign_id: campaign.campaign.campaignid, config_list: [{
      type: 'remain', advanced_day: 'remain', day_number: null, advanced_day_number: null, config_list: []
    }]
  }

  for (const item of self.auto_condition_action_checkbox_list) {
    if (!item.value) continue

    if (item.key === 'auto_position') {
      const auto_position_keyword_response = await self.$http.get(self.API.URL_API_SRV_1 + '/auto_position/v2/detail', {
        ...self.cf(), params: {
          mipeeUserId: self.$store.state.userInfo.username, campaignId: campaign.campaign.campaignid
        }
      })
      console.log('auto_position_keyword_response', auto_position_keyword_response)

      if (auto_position_keyword_response && auto_position_keyword_response.body && auto_position_keyword_response.body.length) {
        const [config_template] = auto_position_keyword_response.body

        const form = {
          config_list: [{
            config_list: [{
              name: 'Cấu hình duy trì vị trí tự động - Quảng cáo từ khóa',
              level: 'campaign',
              not_in: self.clone(action_template),
              condition_action_list: [],
              radio: '2',
              time: '',
              times: config_template.times.map(i => ({start_time: i.startTime, end_time: i.endTime}))
            }]
          }]
        }

        // todo: tăng tiền
        const first_item = {
          condition_group: [{
            condition_list: []
          }], ...self.clone(action_template)
        }
        if (config_template.upValue) {
          first_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '>',
            value: config_template.downValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        if (config_template.fromValue) {
          first_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '>',
            value: config_template.toValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        first_item.action_match_type_0 = 'increase'
        first_item.update_price_type_match_type_0 = 'value'
        first_item.update_price_value_match_type_0 = config_template.maxValue
        first_item.update_type_max_price_match_type_0 = 'value'
        first_item.update_max_price_match_type_0 = config_template.maxPrice
        first_item.action_match_type_1 = 'increase'
        first_item.update_price_type_match_type_1 = 'value'
        first_item.update_price_value_match_type_1 = config_template.maxValue
        first_item.update_type_max_price_match_type_1 = 'value'
        first_item.update_max_price_match_type_1 = config_template.maxPrice
        if (first_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(first_item)

        // todo: giảm tiền khi không đạt vị trí
        const second_item = {
          condition_group: [{
            condition_list: []
          }], ...self.clone(action_template)
        }
        if (config_template.upValue) {
          second_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '<',
            value: config_template.upValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        if (config_template.fromValue) {
          second_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '<',
            value: config_template.fromValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        second_item.action_match_type_0 = 'increase'
        second_item.update_price_type_match_type_0 = 'value'
        second_item.update_price_value_match_type_0 = config_template.minValue
        second_item.update_type_max_price_match_type_0 = 'value'
        second_item.update_max_price_match_type_0 = config_template.minPrice
        second_item.action_match_type_1 = 'increase'
        second_item.update_price_type_match_type_1 = 'value'
        second_item.update_price_value_match_type_1 = config_template.minValue
        second_item.update_type_max_price_match_type_1 = 'value'
        second_item.update_max_price_match_type_1 = config_template.minPrice
        if (second_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(second_item)

        // todo: giảm tiền khi đạt vị trí
        if (config_template.reduceIf) {
          const third_item = {
            condition_group: [{
              condition_list: []
            }], ...self.clone(action_template)
          }
          if (config_template.upValue) {
            third_item.condition_group[0].condition_list.push({
              label: 'avg_rank',
              expression: '>',
              value: config_template.upValue,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '&&',
              level: 'detail',
              time: 'today',
              time_range: null
            })
          }
          if (config_template.fromValue) {
            third_item.condition_group[0].condition_list.push({
              label: 'avg_rank',
              expression: '>',
              value: config_template.fromValue,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '&&',
              level: 'detail',
              time: 'today',
              time_range: null
            })
            third_item.condition_group[0].condition_list.push({
              label: 'avg_rank',
              expression: '<',
              value: config_template.toValue,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '&&',
              level: 'detail',
              time: 'today',
              time_range: null
            })
          }
          third_item.condition_group[0].condition_list.push({
            label: 'click',
            expression: '>',
            value: 0,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
          third_item.action_match_type_0 = 'increase'
          third_item.update_price_type_match_type_0 = 'value'
          third_item.update_price_value_match_type_0 = config_template.reduceIf
          third_item.update_type_min_price_match_type_0 = 'value'
          third_item.update_min_price_match_type_0 = config_template.minPrice
          third_item.action_match_type_1 = 'increase'
          third_item.update_price_type_match_type_1 = 'value'
          third_item.update_price_value_match_type_1 = config_template.reduceIf
          third_item.update_type_min_price_match_type_1 = 'value'
          third_item.update_min_price_match_type_1 = config_template.minPrice
          if (third_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(third_item)
        }

        if (config_template.stopAction === 1) {
          form.config_list[0].config_list[0].not_in.action_match_type_0 = 'pause'
          form.config_list[0].config_list[0].not_in.action_match_type_1 = 'pause'
        }
        if (config_template.stopAction === 3) {
          form.config_list[0].config_list[0].not_in.action_match_type_0 = 'value'
          form.config_list[0].config_list[0].not_in.update_price_value_match_type_0 = config_template.stopAction3
          form.config_list[0].config_list[0].not_in.action_match_type_1 = 'value'
          form.config_list[0].config_list[0].not_in.update_price_value_match_type_1 = config_template.stopAction3
        }

        if (form.config_list[0].config_list[0].condition_action_list.length) {
          auto_condition_action_config.config_list[0].config_list.push(form.config_list[0].config_list[0])

          await self.$http.post(self.API.URL_API_SRV_1 + '/auto_position/v2/status', {
            ids: auto_position_keyword_response.body.map(i => i.id),
            status: 0,
            mipeeUserId: self.$store.state.userInfo.username
          }, self.cf())
        }
      }
    }

    if (item.key === 'auto_cir') {
      const auto_cir_response = await self.$http.get(self.API.URL_API_SRV_1 + '/auto_cir', {
        ...self.cf(), params: {
          mipeeUserId: self.$store.state.userInfo.username, campaignId: campaign.campaign.campaignid
        }
      })
      console.log('auto_cir_response', auto_cir_response)
      if (auto_cir_response.body && auto_cir_response.body.length) {
        const [config_template] = auto_cir_response.body

        const form = {
          campaign_id: campaign.campaign.campaignid, config_list: [{
            type: 'remain', advanced_day: 'remain', day_number: null, advanced_day_number: null, config_list: [{
              name: 'Cấu hình tối ưu theo CIR - Quảng cáo từ khóa',
              level: 'campaign',
              advanced_day: 'remain',
              advanced_day_number: null,
              not_in: self.clone(action_template),
              condition_action_list: [],
              radio: '1',
              time: '',
              times: []
            }]
          }]
        }

        const cir_label = config_template.cirType === 'broad' ? 'broad_cir' : 'direct_cir'

        // todo: tăng tiền
        const first_item = {
          condition_group: [{
            condition_list: [{
              label: cir_label,
              expression: '<',
              value: config_template.fromCir + 1,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }], ...self.clone(action_template)
          }, {
            condition_list: [{
              label: cir_label,
              expression: '===',
              value: 0,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }, {
              label: 'cost',
              expression: '<',
              value: config_template.case2Min,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }], ...self.clone(action_template)
          }], ...self.clone(action_template)
        }
        first_item.action_match_type_0 = 'increase'
        first_item.update_price_type_match_type_0 = 'value'
        first_item.update_price_value_match_type_0 = config_template.price
        first_item.update_type_max_price_match_type_0 = 'value'
        first_item.update_max_price_match_type_0 = config_template.maxPrice
        first_item.action_match_type_1 = 'increase'
        first_item.update_price_type_match_type_1 = 'value'
        first_item.update_price_value_match_type_1 = config_template.price
        first_item.update_type_max_price_match_type_1 = 'value'
        first_item.update_max_price_match_type_1 = config_template.maxPrice
        if (first_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(first_item)

        // todo: giảm tiền 1
        const second_item = {
          condition_group: [{
            condition_list: [{
              label: cir_label,
              expression: '>',
              value: config_template.fromCir + 1,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }]
          }], ...self.clone(action_template)
        }
        second_item.action_match_type_0 = config_template.case1Type === 'stop' ? 'pause' : config_template.case1Type
        second_item.update_price_type_match_type_0 = 'value'
        second_item.update_price_value_match_type_0 = config_template.case1Type === 'value' ? config_template.case1Value : config_template.case1Reduce
        second_item.update_type_min_price_match_type_0 = 'value'
        second_item.update_min_price_match_type_0 = config_template.case1ReduceMin
        second_item.action_match_type_1 = config_template.case1Type === 'stop' ? 'pause' : config_template.case1Type
        second_item.update_price_type_match_type_1 = 'value'
        second_item.update_price_value_match_type_1 = config_template.case1Type === 'value' ? config_template.case1Value : config_template.case1Reduce
        second_item.update_type_min_price_match_type_1 = 'value'
        second_item.update_min_price_match_type_1 = config_template.case1ReduceMin
        if (second_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(second_item)

        // todo: giảm tiền 2
        const third_item = {
          condition_group: [{
            condition_list: [{
              label: cir_label,
              expression: '===',
              value: 0,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }, {
              label: 'cost',
              expression: '>',
              value: config_template.case2Min,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }], ...self.clone(action_template)
          }], ...self.clone(action_template)
        }
        third_item.action_match_type_0 = config_template.case2Type === 'stop' ? 'pause' : config_template.case2Type
        third_item.update_price_type_match_type_0 = 'value'
        third_item.update_price_value_match_type_0 = config_template.case2Type === 'value' ? config_template.case2Value : config_template.case2Reduce
        third_item.update_type_min_price_match_type_0 = 'value'
        third_item.update_min_price_match_type_0 = config_template.case2ReduceMin
        third_item.action_match_type_1 = config_template.case2Type === 'stop' ? 'pause' : config_template.case2Type
        third_item.update_price_type_match_type_1 = 'value'
        third_item.update_price_value_match_type_1 = config_template.case2Type === 'value' ? config_template.case2Value : config_template.case2Reduce
        third_item.update_type_min_price_match_type_1 = 'value'
        third_item.update_min_price_match_type_1 = config_template.case2ReduceMin
        if (third_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(third_item)

        if (form.config_list[0].config_list[0].condition_action_list.length) {
          auto_condition_action_config.config_list[0].config_list.push(form.config_list[0].config_list[0])

          await self.$http.post(self.API.URL_API_SRV_1 + '/auto_cir/status', {
            ids: auto_cir_response.body.map(i => i.id), status: 0, mipeeUserId: self.$store.state.userInfo.username
          }, self.cf())
        }
      }
    }

    if (item.key === 'anti_click') {
      const anti_click_response = await self.$http.get(self.API.URL_API_SRV_1 + '/anti_click/v2/detail', {
        ...self.cf(), params: {
          mipeeUserId: self.$store.state.userInfo.username, campaignId: campaign.campaign.campaignid
        }
      })
      console.log('anti_click_response', anti_click_response)

      if (anti_click_response.body && anti_click_response.body.length) {
        const [config_template] = anti_click_response.body

        const form = {
          campaign_id: campaign.campaign.campaignid, config_list: [{
            type: 'remain', advanced_day: 'remain', day_number: null, advanced_day_number: null, config_list: [{
              name: 'Cấu hình chống click ảo - Quảng cáo từ khóa',
              level: 'campaign',
              advanced_day: 'remain',
              advanced_day_number: null,
              not_in: self.clone(action_template),
              condition_action_list: [],
              radio: '1',
              time: '',
              times: []
            }]
          }]
        }

        if (config_template.cir) {
          const cir_label = config_template.cirType === 'broad' ? 'broad_cir' : 'direct_cir'
          const first_item = {
            condition_group: [{
              condition_list: [{
                label: cir_label,
                expression: '>',
                value: config_template.cir,
                value_p: '',
                value_t: [],
                match_type: 'all',
                post_expression: '&&',
                level: 'detail',
                time: 'today',
                time_range: null
              }]
            }, {
              condition_list: [{
                label: cir_label,
                expression: '===',
                value: 0,
                value_p: '',
                value_t: [],
                match_type: 'all',
                post_expression: '&&',
                level: 'detail',
                time: 'today',
                time_range: null
              }, {
                label: 'cost',
                expression: '>',
                value: config_template.minCost,
                value_p: '',
                value_t: [],
                match_type: 'all',
                post_expression: '||',
                level: 'detail',
                time: 'today',
                time_range: null
              }]
            }], ...self.clone(action_template)
          }
          first_item.action_match_type_0 = config_template.detectType === 3 ? 'value' : 'pause'
          first_item.update_price_type_match_type_0 = 'value'
          first_item.update_price_value_match_type_0 = config_template.detectValue3
          first_item.action_match_type_1 = config_template.detectType === 3 ? 'value' : 'pause'
          first_item.update_price_type_match_type_1 = 'value'
          first_item.update_price_value_match_type_1 = config_template.detectValue3
          if (first_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(first_item)
        }

        // todo: giảm tiền

        if (form.config_list[0].config_list[0].condition_action_list.length) {
          auto_condition_action_config.config_list[0].config_list.push(form.config_list[0].config_list[0])

          await self.$http.post(self.API.URL_API_SRV_1 + '/anti_click/v2/status', {
            ids: anti_click_response.body.map(i => i.id), status: 0, mipeeUserId: self.$store.state.userInfo.username
          }, self.cf())
        }
      }
    }
  }

  if (auto_condition_action_config.config_list[0].config_list.length) {
    campaign.auto_condition_action = auto_condition_action_config

    const update_form = {
      item_ids: [],
      campaign_ids: [campaign.campaign.campaignid],
      keywords: [],
      campaign_id: null,
      config_list: auto_condition_action_config.config_list,
      shop_id: self.shop._id.toString()
    }
    await self.$http.post(self.API.URL_API_SRV_2 + '/mipee/auto_condition_action/update', update_form, self.cf())
  }
}

export async function convert_auto_config_from_keyword(campaign, keyword, action_template, self) {

  const auto_condition_action_config = {
    campaign_detail_id: campaign.campaign.campaignid, keyword_list: [keyword.keyword], config_list: [{
      type: 'remain', advanced_day: 'remain', day_number: null, advanced_day_number: null, config_list: []
    }]
  }

  for (const item of self.auto_condition_action_checkbox_list) {
    if (!item.value) continue

    if (item.key === 'auto_position') {
      if (keyword.auto_position) {
        const config_template = keyword.auto_position

        const form = {
          config_list: [{
            config_list: [{
              name: 'Cấu hình duy trì vị trí tự động - Quảng cáo từ khóa',
              level: 'campaign',
              not_in: self.clone(action_template),
              condition_action_list: [],
              radio: '2',
              time: '',
              times: config_template.times.map(i => ({start_time: i.startTime, end_time: i.endTime}))
            }]
          }]
        }

        // todo: tăng tiền
        const first_item = {
          condition_group: [{
            condition_list: []
          }], ...self.clone(action_template)
        }
        if (config_template.upValue) {
          first_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '>',
            value: config_template.downValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        if (config_template.fromValue) {
          first_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '>',
            value: config_template.toValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        first_item.action_match_type_0 = 'increase'
        first_item.update_price_type_match_type_0 = 'value'
        first_item.update_price_value_match_type_0 = config_template.maxValue
        first_item.update_type_max_price_match_type_0 = 'value'
        first_item.update_max_price_match_type_0 = config_template.maxPrice
        first_item.action_match_type_1 = 'increase'
        first_item.update_price_type_match_type_1 = 'value'
        first_item.update_price_value_match_type_1 = config_template.maxValue
        first_item.update_type_max_price_match_type_1 = 'value'
        first_item.update_max_price_match_type_1 = config_template.maxPrice
        if (first_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(first_item)

        // todo: giảm tiền khi không đạt vị trí
        const second_item = {
          condition_group: [{
            condition_list: []
          }], ...self.clone(action_template)
        }
        if (config_template.upValue) {
          second_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '<',
            value: config_template.upValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        if (config_template.fromValue) {
          second_item.condition_group[0].condition_list.push({
            label: 'avg_rank',
            expression: '<',
            value: config_template.fromValue,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
        }
        second_item.action_match_type_0 = 'increase'
        second_item.update_price_type_match_type_0 = 'value'
        second_item.update_price_value_match_type_0 = config_template.minValue
        second_item.update_type_max_price_match_type_0 = 'value'
        second_item.update_max_price_match_type_0 = config_template.minPrice
        second_item.action_match_type_1 = 'increase'
        second_item.update_price_type_match_type_1 = 'value'
        second_item.update_price_value_match_type_1 = config_template.minValue
        second_item.update_type_max_price_match_type_1 = 'value'
        second_item.update_max_price_match_type_1 = config_template.minPrice
        if (second_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(second_item)

        // todo: giảm tiền khi đạt vị trí
        if (config_template.reduceIf) {
          const third_item = {
            condition_group: [{
              condition_list: []
            }], ...self.clone(action_template)
          }
          if (config_template.upValue) {
            third_item.condition_group[0].condition_list.push({
              label: 'avg_rank',
              expression: '>',
              value: config_template.upValue,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '&&',
              level: 'detail',
              time: 'today',
              time_range: null
            })
          }
          if (config_template.fromValue) {
            third_item.condition_group[0].condition_list.push({
              label: 'avg_rank',
              expression: '>',
              value: config_template.fromValue,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '&&',
              level: 'detail',
              time: 'today',
              time_range: null
            })
            third_item.condition_group[0].condition_list.push({
              label: 'avg_rank',
              expression: '<',
              value: config_template.toValue,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '&&',
              level: 'detail',
              time: 'today',
              time_range: null
            })
          }
          third_item.condition_group[0].condition_list.push({
            label: 'click',
            expression: '>',
            value: 0,
            value_p: '',
            value_t: [],
            match_type: 'all',
            post_expression: '&&',
            level: 'detail',
            time: 'today',
            time_range: null
          })
          third_item.action_match_type_0 = 'increase'
          third_item.update_price_type_match_type_0 = 'value'
          third_item.update_price_value_match_type_0 = config_template.reduceIf
          third_item.update_type_min_price_match_type_0 = 'value'
          third_item.update_min_price_match_type_0 = config_template.minPrice
          third_item.action_match_type_1 = 'increase'
          third_item.update_price_type_match_type_1 = 'value'
          third_item.update_price_value_match_type_1 = config_template.reduceIf
          third_item.update_type_min_price_match_type_1 = 'value'
          third_item.update_min_price_match_type_1 = config_template.minPrice
          if (third_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(third_item)
        }

        if (config_template.stopAction === 1) {
          form.config_list[0].config_list[0].not_in.action_match_type_0 = 'pause'
          form.config_list[0].config_list[0].not_in.action_match_type_1 = 'pause'
        }
        if (config_template.stopAction === 3) {
          form.config_list[0].config_list[0].not_in.action_match_type_0 = 'value'
          form.config_list[0].config_list[0].not_in.update_price_value_match_type_0 = config_template.stopAction3
          form.config_list[0].config_list[0].not_in.action_match_type_1 = 'value'
          form.config_list[0].config_list[0].not_in.update_price_value_match_type_1 = config_template.stopAction3
        }

        if (form.config_list[0].config_list[0].condition_action_list.length) {
          auto_condition_action_config.config_list[0].config_list.push(form.config_list[0].config_list[0])

          await self.$http.post(self.API.URL_API_SRV_1 + '/auto_position/v2/status', {
            ids: [config_template.id], status: 0, mipeeUserId: self.$store.state.userInfo.username
          }, self.cf())
        }
      }
    }

    if (item.key === 'auto_cir') {
      if (keyword.auto_cir) {
        console.log('auto_cir_response', keyword.auto_cir)
        const config_template = keyword.auto_cir

        const form = {
          campaign_id: campaign.campaign.campaignid, config_list: [{
            type: 'remain', advanced_day: 'remain', day_number: null, advanced_day_number: null, config_list: [{
              name: 'Cấu hình tối ưu theo CIR - Quảng cáo từ khóa',
              level: 'campaign',
              advanced_day: 'remain',
              advanced_day_number: null,
              not_in: self.clone(action_template),
              condition_action_list: [],
              radio: '1',
              time: '',
              times: []
            }]
          }]
        }

        const cir_label = config_template.cirType === 'broad' ? 'broad_cir' : 'direct_cir'

        // todo: tăng tiền
        const first_item = {
          condition_group: [{
            condition_list: [{
              label: cir_label,
              expression: '<',
              value: config_template.fromCir + 1,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }], ...self.clone(action_template)
          }, {
            condition_list: [{
              label: cir_label,
              expression: '===',
              value: 0,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }, {
              label: 'cost',
              expression: '<',
              value: config_template.case2Min,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }], ...self.clone(action_template)
          }], ...self.clone(action_template)
        }
        first_item.action_match_type_0 = 'increase'
        first_item.update_price_type_match_type_0 = 'value'
        first_item.update_price_value_match_type_0 = config_template.price
        first_item.update_type_max_price_match_type_0 = 'value'
        first_item.update_max_price_match_type_0 = config_template.maxPrice
        first_item.action_match_type_1 = 'increase'
        first_item.update_price_type_match_type_1 = 'value'
        first_item.update_price_value_match_type_1 = config_template.price
        first_item.update_type_max_price_match_type_1 = 'value'
        first_item.update_max_price_match_type_1 = config_template.maxPrice
        if (first_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(first_item)

        // todo: giảm tiền 1
        const second_item = {
          condition_group: [{
            condition_list: [{
              label: cir_label,
              expression: '>',
              value: config_template.fromCir + 1,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }]
          }], ...self.clone(action_template)
        }
        second_item.action_match_type_0 = config_template.case1Type === 'stop' ? 'pause' : config_template.case1Type
        second_item.update_price_type_match_type_0 = 'value'
        second_item.update_price_value_match_type_0 = config_template.case1Type === 'value' ? config_template.case1Value : config_template.case1Reduce
        second_item.update_type_min_price_match_type_0 = 'value'
        second_item.update_min_price_match_type_0 = config_template.case1ReduceMin
        second_item.action_match_type_1 = config_template.case1Type === 'stop' ? 'pause' : config_template.case1Type
        second_item.update_price_type_match_type_1 = 'value'
        second_item.update_price_value_match_type_1 = config_template.case1Type === 'value' ? config_template.case1Value : config_template.case1Reduce
        second_item.update_type_min_price_match_type_1 = 'value'
        second_item.update_min_price_match_type_1 = config_template.case1ReduceMin
        if (second_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(second_item)

        // todo: giảm tiền 2
        const third_item = {
          condition_group: [{
            condition_list: [{
              label: cir_label,
              expression: '===',
              value: 0,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }, {
              label: 'cost',
              expression: '>',
              value: config_template.case2Min,
              value_p: '',
              value_t: [],
              match_type: 'all',
              post_expression: '||',
              level: 'detail',
              time: 'today',
              time_range: null
            }], ...self.clone(action_template)
          }], ...self.clone(action_template)
        }
        third_item.action_match_type_0 = config_template.case2Type === 'stop' ? 'pause' : config_template.case2Type
        third_item.update_price_type_match_type_0 = 'value'
        third_item.update_price_value_match_type_0 = config_template.case2Type === 'value' ? config_template.case2Value : config_template.case2Reduce
        third_item.update_type_min_price_match_type_0 = 'value'
        third_item.update_min_price_match_type_0 = config_template.case2ReduceMin
        third_item.action_match_type_1 = config_template.case2Type === 'stop' ? 'pause' : config_template.case2Type
        third_item.update_price_type_match_type_1 = 'value'
        third_item.update_price_value_match_type_1 = config_template.case2Type === 'value' ? config_template.case2Value : config_template.case2Reduce
        third_item.update_type_min_price_match_type_1 = 'value'
        third_item.update_min_price_match_type_1 = config_template.case2ReduceMin
        if (third_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(third_item)

        if (form.config_list[0].config_list[0].condition_action_list.length) {
          auto_condition_action_config.config_list[0].config_list.push(form.config_list[0].config_list[0])

          await self.$http.post(self.API.URL_API_SRV_1 + '/auto_cir/status', {
            ids: [keyword.auto_cir.id], status: 0, mipeeUserId: self.$store.state.userInfo.username
          }, self.cf())
        }
      }
    }

    if (item.key === 'anti_click') {
      if (keyword.anti_click) {
        console.log('anti_click_response', keyword.anti_click)
        const config_template = keyword.anti_click

        const form = {
          campaign_id: campaign.campaign.campaignid, config_list: [{
            type: 'remain', advanced_day: 'remain', day_number: null, advanced_day_number: null, config_list: [{
              name: 'Cấu hình chống click ảo - Quảng cáo từ khóa',
              level: 'campaign',
              advanced_day: 'remain',
              advanced_day_number: null,
              not_in: self.clone(action_template),
              condition_action_list: [],
              radio: '1',
              time: '',
              times: []
            }]
          }]
        }

        if (config_template.cir) {
          const cir_label = config_template.cirType === 'broad' ? 'broad_cir' : 'direct_cir'
          const first_item = {
            condition_group: [{
              condition_list: [{
                label: cir_label,
                expression: '>',
                value: config_template.cir,
                value_p: '',
                value_t: [],
                match_type: 'all',
                post_expression: '&&',
                level: 'detail',
                time: 'today',
                time_range: null
              }]
            }, {
              condition_list: [{
                label: cir_label,
                expression: '===',
                value: 0,
                value_p: '',
                value_t: [],
                match_type: 'all',
                post_expression: '&&',
                level: 'detail',
                time: 'today',
                time_range: null
              }, {
                label: 'cost',
                expression: '>',
                value: config_template.minCost,
                value_p: '',
                value_t: [],
                match_type: 'all',
                post_expression: '||',
                level: 'detail',
                time: 'today',
                time_range: null
              }]
            }], ...self.clone(action_template)
          }
          first_item.action_match_type_0 = config_template.detectType === 3 ? 'value' : 'pause'
          first_item.update_price_type_match_type_0 = 'value'
          first_item.update_price_value_match_type_0 = config_template.detectValue3
          first_item.action_match_type_1 = config_template.detectType === 3 ? 'value' : 'pause'
          first_item.update_price_type_match_type_1 = 'value'
          first_item.update_price_value_match_type_1 = config_template.detectValue3
          if (first_item.condition_group[0].condition_list.length) form.config_list[0].config_list[0].condition_action_list.push(first_item)
        }

        // todo: giảm tiền

        if (form.config_list[0].config_list[0].condition_action_list.length) {
          auto_condition_action_config.config_list[0].config_list.push(form.config_list[0].config_list[0])

          await self.$http.post(self.API.URL_API_SRV_1 + '/anti_click/v2/status', {
            ids: [keyword.anti_click.id], status: 0, mipeeUserId: self.$store.state.userInfo.username
          }, self.cf())
        }
      }
    }
  }

  if (auto_condition_action_config.config_list[0].config_list.length) {
    campaign.auto_condition_action = auto_condition_action_config

    const update_form = {
      item_ids: [],
      campaign_ids: [],
      campaign_detail_id: campaign.campaign.campaignid,
      keyword_list: [keyword.keyword],
      config_list: auto_condition_action_config.config_list,
      shop_id: self.shop._id.toString()
    }
    await self.$http.post(self.API.URL_API_SRV_2 + '/mipee/auto_condition_action/update', update_form, self.cf())
  }
}



// WEBPACK FOOTER //
// ./src/pages/pas/script/convert_config.js